import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import { f as fetchHTML } from './fetchHTML-9PhJW9Dj.js';
import './notyf-DIw0RvBj.js';

class LoadMore extends HTMLElement {
  html;
  url = this.querySelector('a').href;
  direction = this.dataset.direction;
  currentPage = this.dataset.currentPage;
  totalPages = this.dataset.totalPages;
  loadMoreButton = this.querySelector('a');
  productList = document.querySelector('[data-products-list]');
  loadMoreButtons = document.querySelectorAll('load-more a');
  pageTitle = this.dataset.pageTitle;

  connectedCallback() {
    this.loadMoreButton.addEventListener('click', (event) => this.loadMore(event));
  }

  /**
   * loadMore
   * @param {Event} event - The event object
   */
  async loadMore(event) {
    event.preventDefault();

    this.html = await this.fetchMore();
    this.sendViewItemListEvent();
    this.addProducts();
    this.updateLoadMoreURL();
    this.updateSearchParams();

    Pubsub.publish('load-more:success');
  }

  /**
   * fetchMore
   */
  async fetchMore() {
    try {
      this.toggleLoadMoreButtons(true);
      return await fetchHTML(this.url);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.toggleLoadMoreButtons(false);
    }
  }

  /**
   * Send view_item_list event for newly loaded products
   */
  sendViewItemListEvent() {
    const productList = this.html.querySelector('[data-products-list]');
    if (!productList) return;

    const listName = productList.dataset.gaItemListName;
    const items = [...productList.querySelectorAll('[data-product-json]')].map(({ textContent }) =>
      JSON.parse(textContent)
    );

    if (!items.length) return;

    Shopify.analytics.publish('karl:view_item_list', { listName, items });
  }

  /**
   * addProducts
   */
  addProducts() {
    const fetchedProducts = this.html.querySelectorAll('[data-products-list] > li');

    if (!fetchedProducts) return;

    if (this.direction === 'previous') {
      this.productList.prepend(...fetchedProducts);
    } else if (this.direction === 'next') {
      this.productList.append(...fetchedProducts);
    }
  }

  /**
   * Update URL
   * @param {HTML} html The HTML of the page
   */
  updateLoadMoreURL() {
    const loadMoreElement = this.html.querySelector(
      `load-more[data-direction="${this.direction}"]`
    );

    if (!loadMoreElement) return this.remove();
    this.replaceWith(loadMoreElement);
  }

  /**
   * Toggle the load more button
   */
  toggleLoadMoreButtons(loading) {
    this.loadMoreButtons.forEach((button) => {
      button.classList.toggle('button--loading', loading);
    });
  }

  /**
   * Update the search params
   */
  updateSearchParams() {
    history.replaceState(null, '', this.url);
  }
}

customElements.define('load-more', LoadMore);
